const deviceEventSettings = window.filterEnvironmentDeviceSettings(
  require('cloud-utils/config/events/default.json').deviceEventSettings
)
const { jobStatusType } = require('../../js/constants')
const {
  RequestRetryBackOffHelper
} = require('../../js/request-retry-backoff-helper')
const SemVerGte = require('semver/functions/gte')
const AccidentAndGsensorMinVersion = '3.10.0'
const FatigueMinVersion =
  (deviceEventSettings.find(e => e.name === 'fatigue') || {}).fromVersion ||
  '14.7.0'
angular
  .module('surfsightApp.controllers')
  .controller('edgeAgressiveReportsController', [
    '$scope',
    '$rootScope',
    '$log',
    '$state',
    '$timeout',
    '$interval',
    '$location',
    '$window',
    '$http',
    '$filter',
    '$localStorage',
    '$mdDialog',
    '$mdMedia',
    '$mdSidenav',
    '$mdToast',
    '$mdColors',
    'edgeFactory',
    'edgeGroupFactory',
    'leafletData',
    'nominatimLookUp',
    '$stateParams',
    'NgTableParams',
    '$q',
    function (
      $scope,
      $rootScope,
      $log,
      $state,
      $timeout,
      $interval,
      $location,
      $window,
      $http,
      $filter,
      $localStorage,
      $mdDialog,
      $mdMedia,
      $mdSidenav,
      $mdToast,
      $mdColors,
      edgeFactory,
      edgeGroupFactory,
      leafletData,
      nominatimLookUp,
      $stateParams,
      NgTableParams,
      $q
    ) {
      const pageLimit = window.deviceReportPaginationLimit
      const groupId = parseInt($stateParams.edge_group_id)
      const deviceId = parseInt($stateParams.edge_id)
      const $translate = $filter('translate')

      $scope.isGroupReport = !deviceId
      $scope.fatigueColumnTitle = $scope.isGroupReport
        ? `${$translate('possibleFatigue')} / ${$translate('fatigue')}`
        : $translate('possibleFatigue')
      let lastRequestQueryParams
      $scope.edge_name = ''
      const stateName = $state.current.name
      $scope.isMobile = $window.innerWidth <= 768
      $scope.showMessageToast = function (message) {
        var toast = $mdToast
          .simple()
          .textContent(message)
          .action($translate('ok'))
          .position('bottom')
          .hideDelay(5000)
          .actionKey('F1')
          .parent('#device-ui-settings-container')

        $mdToast
          .show(toast)
          .then(function (response) {})
          .catch(() => {})
      }
      const initTable = () => {
        $scope.ngAggressiveReportTable = {
          columns: {
            dashcamName: {
              title: $translate('dashcamName')
            },
            acceleration: {
              title: $translate('acceleration')
            },
            deAcceleration: {
              title: $translate('deAcceleration')
            },
            dangerousRightTurn: {
              title: $translate('dangerousRightTurn')
            },
            dangerousLeftTurn: {
              title: $translate('dangerousLeftTurn')
            },
            distractedDriving: {
              title: $translate('distractedDriving')
            },
            smoking: {
              title: $translate('smoking')
            },
            foodDrink: {
              title: $translate('foodDrink')
            },
            cellPhoneUse: {
              title: $translate('cellPhoneUse')
            },
            driverUnbelted: {
              title: $translate('driverUnbelted')
            },
            possibleFatigue: {
              title: $translate('possibleFatigue')
            },
            total: {
              title: $translate('total')
            }
          },
          ngTableParams: new NgTableParams(
            {
              noPager: true,
              page: 1, // show first page
              count: pageLimit // count per page
            },
            {
              counts: [],
              filterDelay: 300,
              getData: params => {
                return new Promise((resolve, reject) => {
                  ;(async () => {
                    if ($scope.groupDevicesState) {
                      $scope.groupDevicesState.page = params._params.page
                      $scope.groupDevicesState.limit = params._params.count
                    }
                    const {
                      tableRows,
                      totalRecords
                    } = await getEdgeReportsData()
                    params.total(totalRecords)
                    resolve(tableRows)
                  })()
                })
              }
            }
          )
        }
        $scope.reportName =
          (
            `${$scope.edge_name} ` +
            `${$translate('aggressiveReport')} ` +
            `(${$rootScope.reportDateRangeFilter.name_formate2}` +
            `${
              $rootScope.reportDateRangeFilter.current_year
                ? ' ' + $rootScope.reportDateRangeFilter.current_year
                : ''
            })`
          )
            .replace(/ {2}- /g, '-')
            .replace(/ {2}/g, ' ')
            .replace(/ /g, '-') + '.csv'
      }
      const initReport = () => {
        $timeout(() => {
          initTable()
        })
      }
      $scope.resetCurrentReportDownload = () => {
        $scope.downloadStatus = {
          downloadRequestId: '',
          downloadRequestStatus: jobStatusType.INITIAL,
          downloadUrl: ''
        }
      }
      $scope.resetCurrentReportDownload()
      const retryCurrentReportDownload = async (
        signal = new AbortController()
      ) => {
        const requestTimeout = $q.defer()
        signal.addEventListener('abort', () => {
          requestTimeout.resolve()
        })
        $scope.downloadStatus.downloadRequestId = ''
        $scope.downloadStatus.downloadRequestStatus = jobStatusType.IN_QUEUE
        const requestRetryBackOffIterator = new RequestRetryBackOffHelper(
          50,
          5,
          true,
          30
        ).getIterator()
        for await (const { attempts } of requestRetryBackOffIterator) {
          try {
            if (signal.aborted) break
            const queryParams = new URLSearchParams(
              attempts > 1
                ? {
                    downloadRequestId: $scope.downloadStatus.downloadRequestId,
                    organizationId: $rootScope.currentUserOrganization.id,
                    groupId: groupId
                  }
                : lastRequestQueryParams
            )
            ;['page', 'limit'].forEach(param => {
              queryParams.delete(param)
            })
            const requestJson = {
              method: 'GET',
              url:
                EDGE_BASEURL +
                '/aggressive-report-download?' +
                queryParams.toString(),
              timeout: requestTimeout
            }
            const response = await $http(requestJson)
            if (response.data) {
              const downloadRequestStatus = response.data.downloadStatus
              if (attempts === 1) {
                $scope.downloadStatus.downloadRequestId =
                  response.data.downloadRequestId
              }
              if (downloadRequestStatus) {
                $scope.downloadStatus.downloadRequestStatus = downloadRequestStatus
                if (
                  downloadRequestStatus === jobStatusType.COMPLETED ||
                  signal.aborted
                ) {
                  $scope.downloadStatus.downloadUrl = response.data.url
                  triggerDownload($scope.downloadStatus.downloadUrl)
                  break
                }
                if (downloadRequestStatus === jobStatusType.FAILED) {
                  throw new Error(response.data.status.error)
                }
              }
            }
          } catch (ex) {
            $scope.downloadStatus.downloadRequestStatus = jobStatusType.FAILED
            $scope.showMessageToast(ex.data.status.error)
            console.error(ex)
            break
          }
          $scope.$apply()
        }
        $scope.$apply()
      }
      function triggerDownload (url) {
        const a = document.createElement('a')
        a.href = url
        a.download = ''
        a.style.display = 'none'
        document.body.appendChild(a)

        a.click()
        document.body.removeChild(a)
      }
      let previousDownloadRequestAbortController = new AbortController()
      $scope.downloadCurrentReport = () => {
        if (
          previousDownloadRequestAbortController &&
          !previousDownloadRequestAbortController.signal.aborted
        ) {
          previousDownloadRequestAbortController.abort()
        }
        previousDownloadRequestAbortController = new AbortController()
        retryCurrentReportDownload(
          previousDownloadRequestAbortController.signal
        )
      }

      $scope.showSearchOption = () => !deviceId
      if (
        [
          'home.common.reports.edge',
          'home.common.reports.edgereportDashboard'
        ].includes(stateName)
      ) {
        let edge = edgeFactory.list.find(e => e.id === deviceId)
        if (edge) {
          $scope.edge = edge
          $scope.edge_name = $scope.edge.name
          initReport()
        } else {
          const requestId = window.makeId(5)
          $scope.$emit('LOAD_DEVICE_DETAILS_REQUEST', {
            id: deviceId,
            requestId
          })
          $scope.$on('LOAD_DEVICE_DETAILS_SUCCESS', (e, data) => {
            if (data.id === deviceId && data.requestId === requestId) {
              edge = edgeFactory.list.find(e => e.id === deviceId)
              $scope.edge = edge
              $scope.edge_name = $scope.edge.name
              initReport()
            }
          })
        }
      } else if (
        [
          'home.common.reports.edgegroup',
          'home.common.reports.edgegroupreportDashboard'
        ].includes(stateName)
      ) {
        if (groupId === -1) {
          $scope.edge_name = 'Devices'
          initReport()
        } else {
          let group = edgeGroupFactory.list.find(e => e.id === groupId)
          if (group) {
            $scope.edgeGroupDetails = group
            $scope.edge_name = group.name
            initReport()
          } else {
            const requestId = window.makeId(5)
            $scope.$emit('LOAD_GROUP_DETAILS_REQUEST', {
              id: groupId,
              requestId
            })
            $scope.$on('LOAD_GROUP_DETAILS_SUCCESS', (e, data) => {
              if (data.id === groupId && data.requestId === requestId) {
                group = edgeGroupFactory.list.find(e => e.id === groupId)
                $scope.edgeGroupDetails = group
                $scope.edge_name = $scope.edgeGroupDetails.name
                initReport()
              }
            })
          }
        }
        $scope.groupDevicesState = {
          searchText: '',
          page: 1,
          limit: pageLimit,
          totalCount: 0,
          dashcam: []
        }
      }
      // mobile screens
      if (
        [
          'home.common.reports.edgegroupreportDashboard',
          'home.common.reports.edgereportDashboard'
        ].includes(stateName)
      ) {
        if (!$rootScope.reportDateRangeFilter) {
          // page does not have search filter information. Redirect
          if (groupId) {
            $state.go('home.common.reports.edgegroup', {
              edge_group_id: groupId
            })
          } else {
            $state.go('home.common.reports.edge', { edge_id: deviceId })
          }
        }
      }
      let searchTextTimer
      $scope.trackSearchText = () => {
        if (deviceId) return
        searchTextTimer && $timeout.cancel(searchTextTimer)
        searchTextTimer = $timeout(() => {
          $scope.groupDevicesState = {
            searchText: $scope.groupDevicesState.searchText,
            page: 1,
            limit: pageLimit,
            totalCount: 0,
            dashcam: []
          }
          $scope.ngAggressiveReportTable.ngTableParams
            .parameters({ page: 1 })
            .reload()
        }, 1500)
      }
      $scope.agressiveTableState = {
        loading: false
      }
      $scope.$on('eventSearchDataResult', (e, data) => {
        $scope.ngAggressiveReportTable.ngTableParams
          .parameters({ page: 1 })
          .reload()
      })
      $scope.showReportTable = (_deviceId, eventConfigId) => {
        const eventConfig = deviceEventSettings.find(
          e => e.id === eventConfigId
        )
        if (!$mdMedia('gt-sm')) {
          $state.go(
            'home.common.reports.edgereportDashboard',
            {
              edge_id: _deviceId,
              eventSearch: $scope.eventSearch,
              reportType: 5,
              eventType: eventConfig.name
            },
            { reload: true }
          )
        } else {
          $state.go(
            'home.common.reports.edge',
            {
              edge_id: _deviceId,
              eventSearch: $scope.eventSearch,
              reportType: 5,
              eventType: eventConfig.name
            },
            { reload: true }
          )
        }
      }
      const getEdgeReportsData = async () => {
        let tableRows = []
        let totalRecords
        const startTime = $rootScope.reportDateRangeFilter.date.start / 1000
        const endTime = $rootScope.reportDateRangeFilter.date.end / 1000
        const queryParams = new URLSearchParams()
        queryParams.append('startTime', startTime)
        queryParams.append('endTime', endTime)
        if (deviceId && $scope.edge) {
          $scope.agressiveTableState.loading = true
          const requestJson = {
            method: 'GET',
            url: `${EDGE_BASEURL}/device/${
              $scope.edge.uri
            }/aggressive-report?${queryParams.toString()}`
          }
          try {
            const deviceAggressiveReportResponse = await $http(requestJson)
            const {
              deviceAggressiveReport
            } = deviceAggressiveReportResponse.data
            if (
              SemVerGte(
                deviceAggressiveReport.semanticVersion,
                AccidentAndGsensorMinVersion
              )
            ) {
              $scope.extendedTableView = true
            }

            $scope.isFatigueEvent = SemVerGte(
              deviceAggressiveReport.semanticVersion,
              FatigueMinVersion
            )
            tableRows = [deviceAggressiveReport]
            totalRecords = 1
          } catch (error) {
            handleServerError(error)
          }
        } else {
          const { page, limit, searchText } = $scope.groupDevicesState
          queryParams.append('searchText', searchText)
          queryParams.append('limit', limit)
          queryParams.append('page', page)
          queryParams.append(
            'organizationId',
            $rootScope.currentUserOrganization.id
          )
          lastRequestQueryParams = `${queryParams.toString()}&groupId=${groupId}`
          const requestJson = {
            method: 'GET',
            url: `${EDGE_BASEURL}/organization/${
              $rootScope.currentUserOrganization.id
            }/group/${groupId}/aggressive-report?${queryParams.toString()}`
          }
          try {
            const groupAggressiveReportResponse = await $http(requestJson)
            const {
              groupAggressiveReport,
              totalCount
            } = groupAggressiveReportResponse.data
            $scope.extendedTableView = true

            $scope.isFatigueEvent = false
            tableRows = [...groupAggressiveReport]
            totalRecords = totalCount
          } catch (error) {
            handleServerError(error)
          }
        }
        return {
          tableRows,
          totalRecords
        }
      }
      $scope.showReportDateFilter = e => {
        $scope.$emit('SHOW_REPORT_DATE_FILTER_EMIT', { event: e })
      }
      const handleServerError = response => {
        $scope.$emit('handleServerError', response)
      }
      $scope.exportReport = () => {
        if ($scope.ngAggressiveReportTable.ngTableParams.data.length > 1) {
          return
        }
        $scope.ngAggressiveReportTable.ngTableParams.settings().$loading = true
        const headers = {
          dashcamName: $translate('dashcamName'),
          acceleration: $translate('acceleration'),
          deAcceleration: $translate('deAcceleration'),
          dangerousRightTurn: $translate('dangerousRightTurn'),
          dangerousLeftTurn: $translate('dangerousLeftTurn'),
          distractedDriving: $translate('distractedDriving'),
          smoking: $translate('smoking'),
          foodDrink: $translate('foodDrink'),
          cellPhoneUse: $translate('cellPhoneUse'),
          driverUnbelted: $translate('driverUnbelted'),
          passenger_unbelted: $translate('passenger_unbelted'),
          accident: $translate('accident'),
          gsensorRegular: $translate('gsensorRegular'),
          gsensorHigh: $translate('gsensorHigh'),
          possibleFatigue: $scope.isFatigueEvent
            ? $translate('fatigue')
            : $translate('possibleFatigue'),
          yawn: $translate('yawning'),
          laneWeaving: $translate('laneWeaving'),
          tailgating: $translate('tailgating'),
          total: $translate('total')
        }
        const report = $scope.ngAggressiveReportTable.ngTableParams.data.map(
          tableRow => {
            return {
              [headers.dashcamName]: tableRow.name || $scope.edge_name,
              [headers.acceleration]: tableRow.acceleration,
              [headers.deAcceleration]: tableRow.de_acceleration,
              [headers.dangerousRightTurn]: tableRow.sharp_turn_right,
              [headers.dangerousLeftTurn]: tableRow.sharp_turn_left,
              [headers.distractedDriving]: tableRow.distracted_driving,
              [headers.smoking]: tableRow.smoking,
              [headers.foodDrink]: tableRow.foodDrink,
              [headers.cellPhoneUse]: tableRow.cellPhoneUse,
              [headers.driverUnbelted]: tableRow.driverUnbelted,
              [headers.passenger_unbelted]: tableRow.passenger_unbelted,
              [headers.accident]: tableRow.accident,
              [headers.gsensorRegular]: tableRow.gsensor_regular || 0,
              [headers.gsensorHigh]: tableRow.gsensor_high || 0,
              [headers.possibleFatigue]: $scope.isFatigueEvent
                ? tableRow.fatigue
                : tableRow.fatigue != null
                ? tableRow.fatigue
                : tableRow.possibleFatigue,
              [headers.yawn]: tableRow.yawn,
              [headers.laneWeaving]: tableRow.lane_weaving,
              [headers.tailgating]: tableRow.tailgating,
              [headers.total]: tableRow.aggressiveEventsCount
            }
          }
        )
        $scope.ngAggressiveReportTable.ngTableParams.settings().$loading = false
        return report
      }
    }
  ])
